<template>
  <div class="dropdown" v-if="model">
    <button
      class="btn dropdown-toggle border w-100"
      type="button"
      id="time-range-dropdown"
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      style="text-align: left"
    >
      <span style="color: #4d4f5c">
        {{ model.option }}
      </span>
    </button>
    <ul class="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
      <li class="dropdown-item">
        <!--   <router-link to class="dropdown-item" name="last_7_days">Last 7 days</router-link> -->
        <input
          :id="`last_7_days-${name}`"
          type="radio"
          v-model="model"
          :value="{ value: 7, option: 'Last 7 days' }"
          name="last_7_days"
          style="display: none"
        />
        <label :for="`last_7_days-${name}`">Last 7 days</label>
      </li>
      <li class="dropdown-item">
        <!-- <router-link to class="dropdown-item" name="last_30_days">Last 30 days</router-link> -->
        <input
          :id="`last_30_days-${name}`"
          type="radio"
          v-model="model"
          :value="{ value: 30, option: 'Last 30 days' }"
          name="last_30_days"
          style="display: none"
        />
        <label :for="`last_30_days-${name}`">Last 30 days</label>
      </li>
      <li class="dropdown-item">
        <!--  <router-link to class="dropdown-item" name="last_90_days">Last 90 days</router-link> -->
        <input
          :id="`last_90_days-${name}`"
          type="radio"
          v-model="model"
          :value="{ value: 90, option: 'Last 90 days' }"
          name="last_90_days"
          style="display: none"
        />
        <label :for="`last_90_days-${name}`">Last 90 days</label>
      </li>
      <li class="dropdown-item">
        <!-- <router-link to class="dropdown-item" name="last_365_days">Last 365 days</router-link> -->
        <input
          :id="`last_365_days-${name}`"
          type="radio"
          v-model="model"
          :value="{ value: 365, option: 'Last 365 days' }"
          name="last_365_days"
          style="display: none"
        />
        <label :for="`last_365_days-${name}`">Last 365 days</label>
      </li>
      <li class="dropdown-item">
        <!-- <router-link to class="dropdown-item" name="all_time">All time</router-link> -->
        <input
          :id="`all_time-${name}`"
          type="radio"
          v-model="model"
          :value="{ value: 'all_time', option: 'All time' }"
          name="all_time"
          style="display: none"
        />
        <label :for="`all_time-${name}`">All time</label>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ['value', 'name'],
  methods: {},
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    // console.log('the model: ', this.model);
  },
};
</script>

<style lang="scss" scoped>
.dropdown-toggle::after {
  position: absolute;
  top: 1em;
  right: 0.5em;
  display: inline-block;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
</style>